import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-bar__row flex items-center gap-2" }
const _hoisted_2 = ["placeholder"]

import { ref, onMounted, watch } from 'vue';
import { Search, X } from 'lucide-vue-next';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { getContext } from '@/composables/useSearch';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  setup(__props) {

const { websiteText } = useWebsiteTexts();
const { search } = getContext();

const searchQuery = ref('');
const searchInput = ref<HTMLInputElement | null>(null);

function clear() {
  searchQuery.value = '';
  searchInput.value?.focus();
}

onMounted(() => {
  searchInput.value?.focus();

  watch(
    () => searchQuery.value,
    () => {
      search(searchQuery.value);
    },
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "searchInput",
      ref: searchInput,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      type: "text",
      placeholder: _unref(websiteText)('header_searchplaceholder').value,
      class: "search-bar__input min-w-0 flex-1 text-foreground placeholder:text-muted-foreground"
    }, null, 8, _hoisted_2), [
      [_vModelText, searchQuery.value]
    ]),
    (searchQuery.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn-bare shrink-0 text-muted-foreground transition-colors hover:text-foreground",
          "aria-label": "Rensa",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (clear()))
        }, [
          _createVNode(_unref(X), { class: "block h-4 w-4" })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Search), { class: "pointer-events-none block h-5 w-5 shrink-0 text-muted-foreground" })
  ]))
}
}

})